"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState, useSyncExternalStore } from "react";
import { setPrivacyChoice, usePrivacyChoice } from "@/lib/privacy-preferences";

const subscribe = () => () => {};
export function PrivacyPreferences() {
  const choice = usePrivacyChoice();
  const [editing, setEditing] = useState(false);
  const ready = useSyncExternalStore(subscribe, () => true, () => false);
  const pathname = usePathname();
  if (!ready || /^\/(admin|ops)(\/|$)/.test(pathname)) return null;
  const open = !choice || editing;
  const gpc = (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
  return <>
    {!open && <div className="bg-[#15263F] px-6 pb-4 text-center"><button type="button" onClick={() => setEditing(true)} className="min-h-10 text-xs text-white underline underline-offset-4">Privacy preferences</button></div>}
    {open && <section aria-label="Privacy preferences" className="fixed inset-x-0 bottom-0 z-[90] border-t border-[#CBD5E1] bg-white px-4 py-4 text-[#172B4D] shadow-[0_-4px_20px_#172b4d12] sm:px-6">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
        <div className="max-w-2xl text-sm leading-relaxed"><strong className="font-semibold">Your privacy choices</strong><p>Essential storage keeps sign-in and checkout working. Optional analytics help us understand visits and referral campaigns. <Link href="/privacy" className="text-[#2457A7] underline">Privacy policy</Link></p>{gpc && <p className="mt-1 text-xs">Your browser&apos;s Global Privacy Control keeps optional tracking off.</p>}</div>
        <div className="flex shrink-0 flex-wrap gap-2">
          <button type="button" onClick={() => { setPrivacyChoice("essential"); setEditing(false); }} className="min-h-11 rounded-lg border border-[#2457A7] px-4 text-sm font-medium text-[#2457A7]">Essential only</button>
          <button type="button" disabled={gpc} onClick={() => { setPrivacyChoice("accepted"); setEditing(false); }} className="min-h-11 rounded-lg border border-[#2457A7] bg-[#2457A7] px-4 text-sm font-medium text-white disabled:opacity-50">Accept optional</button>
          {editing && <button type="button" onClick={() => setEditing(false)} className="min-h-11 px-3 text-sm">Close</button>}
        </div>
      </div>
    </section>}
  </>;
}
